import React, { useRef, useEffect } from "react";
import "./AiMessageModal.css";
import { useDispatch } from "react-redux";
import { useIsMobile } from "../../functions/deviceIdentity/getDeviceType";
import { setAiAssistant } from "../../redux/actions/setAiAssistantAction";
import { saveSettings } from "../../redux/actions/Settings/saveSettingAction";

const AiMessageModalComponent = (props) => {
    const { modalOpen, onCloseReject, onCloseAccept } = props;
    const ref = useRef();
    const dispatch = useDispatch();
    const isMobile = useIsMobile();

    const handleClose = () => {
        onCloseReject();
        ref.current?.close();
    };

    const handleAccept = () => {

        dispatch(setAiAssistant(true));

        const json = {
            aiAssistant: 'true'
        };

        dispatch(saveSettings(json));

        onCloseAccept();
    }

    useEffect(() => {
        if (modalOpen) {
            ref.current?.showModal();
        } else {
            ref.current?.close();
        }

    }, [modalOpen]);

    return (

        <dialog className="gt-modal" aria-labelledby="smartAssistant" ref={ref} >
            <div className="gt-modal-content">
                <div className="gt-modal-content__heading">
                    <h2 id="smartAssistant">Smart task assistant</h2>
                </div>
                <div className="gt-modal-content__body" style={{ fontSize: "24" }}>
                    <p>
                        The assistant feature uses AI and related technologies. This requires us to send your task title to third parties. You can opt into using these features here or at the General tab inside Settings.
                    </p>
                </div>
                <div style={{ display: "flex", justifyContent: "right", padding: '1.5em' } }>
                    <button className="gw-button gw-button--secondary"
                        onClick={() => { handleClose() }}
                        style={{ marginRight: '0.5em' }}
                    >Reject</button>
                    <button className="gw-button gw-button--primary"
                        onClick={() => { handleAccept() }}
                        >Accept</button>
                </div>
            </div>
        </dialog>
    );
};

export default AiMessageModalComponent;